import { React, useState } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import "react-datepicker/dist/react-datepicker.css";
import { TextField } from "@mui/material";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { Divider } from "material-ui";

export default function NewCustomerLandingSpanish(gotoScreen = "") {
    const [view, setView] = useState();
    const handleChange = (event, nextView) => {
        setView(nextView);
    };

    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    return (
        <>
            <h4>Bienvenido!</h4>
            <div className="descRow">Haga clic para llamar al número a continuación y lo conectarán con un especialista de servicio al cliente.</div>
            <br />
            <Divider />
            <br />
            <Grid item>Llame al servicio de atención al cliente al</Grid>
            <Grid item justifyContent="flex-end">
                <b>
                    <a href="tel:8883940577" target="_parent">
                        888-394-0577
                    </a>
                </b>
            </Grid>

            <br />
        </>
    );
}
